// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 30% minmax(min-content, auto) min-content;
  gap: 0;
  padding: var(--spacing-smaller) var(--spacing-largest);
  height: 100vh;
}

:host > * {
  height: 100%;
}

.logo-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.logo {
  width: 45%;
  max-width: 250px;
}

.version {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authentication/authentication.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,2BAAA;EACA,6DAAA;EACA,MAAA;EACA,sDAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[":host {\n  display: grid;\n  grid-template-columns: 100%;\n  grid-template-rows: 30% minmax(min-content, auto) min-content;\n  gap: 0;\n  padding: var(--spacing-smaller) var(--spacing-largest);\n  height: 100vh;\n}\n\n:host > * {\n  height: 100%;\n}\n\n.logo-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.logo {\n  width: 45%;\n  max-width: 250px;\n}\n\n.version {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
